import { User } from '@/models/users/user';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserPermissions } from '@/models/users/user-permissions/user-permissions';
import { axiosService } from '.';

export default class UsersService {
    public async getUser(id: number): Promise<User> {
        return new User((await axiosService.instance.get(`users/${id}`)).data);
    }

    public async getUserByEmail(email: string): Promise<User> {
        return new User((await axiosService.instance.get(`users/by-email/${email}`)).data);
    }

    public async getActualUserPermissions(): Promise<UserPermissions> {
        return new UserPermissions((await axiosService.instance.get('users/organization/custom-permissions')).data);
    }

    public async existsUserByEmail(email: string): Promise<boolean> {
        return (await axiosService.anonymousInstance.get(`users/exists-by-email/${email}`)).data;
    }

    public async logUserAction(userActionLogInfo: UserActionLogInfo): Promise<boolean> {
        return (await axiosService.instance.post('users/organization/log-actions/new', userActionLogInfo)).data;
    }
}

export const usersService = new UsersService();
